module.exports = __webpack_public_path__ + "img/errorIcon.4e7e66ce.png";